var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEraser = function SvgEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.048 14.798a.75.75 0 0 1 1.06 0l6.366 6.365a.75.75 0 0 1-1.06 1.061l-6.366-6.366a.75.75 0 0 1 0-1.06Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.943 10.339a.74.74 0 0 0-.526.22l-.003.002-10.606 10.606a.74.74 0 0 0 0 1.053l.003.002 3.259 3.259h3.025l9.622-9.612a.768.768 0 0 0 0-1.073L25.47 10.56a.741.741 0 0 0-.527-.22ZM20.406 26.98h9.844a.75.75 0 0 0 0-1.5h-8.032l8.562-8.554.005-.005a2.268 2.268 0 0 0 0-3.18l-4.25-4.239-.001-.002a2.24 2.24 0 0 0-3.182 0l-.001.002-10.598 10.598-.001.001a2.241 2.241 0 0 0 0 3.182l.001.002 3.476 3.475c.14.14.331.22.53.22H20.407Z",
    fill: "#3D4043"
  })));
};
export default SvgEraser;